import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import history from './history';
import './react-table-defaults';
import './styles/index.css';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import {StateProvider} from './yeffect/StateProvider'
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';

// eslint-disable-next-line
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { routes } from './fuse-configs/fuseRoutesConfig';
import { FuseLayout, FuseTheme, FuseAuthorization } from '@fuse';
import MainToolbar from './main/MainToolbar';
import MainNavbarContent from './main/MainNavbarContent';
import MainNavbarHeader from './main/MainNavbarHeader';
import MainFooter from './main/MainFooter';
import jssExtend from 'jss-extend'
//import QuickPanel from 'main/quickPanel/QuickPanel';
import store from 'store';

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend()]
});

jss.options.insertionPoint = document.getElementById('jss-insertion-point');
const generateClassName = createGenerateClassName();

ReactDOM.render(
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <StateProvider>
    <Provider store={store}>
      <Router history={history}>
        <FuseAuthorization routes={routes}>
          <FuseTheme>
            <FuseLayout
              routes={routes}
              toolbar={
                <MainToolbar />
              }
              navbarHeader={
                <MainNavbarHeader />
              }
              navbarContent={
                <MainNavbarContent />
              }
              footer={
                <MainFooter />
              }
            />
            {/*<SettingsPanel/>*/}
          </FuseTheme>
        </FuseAuthorization>
      </Router>
    </Provider>
    </StateProvider>
  </JssProvider>
  , document.getElementById('root'));

//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js